import React from 'react';
// SUPPORTCFG: a pure build-time read, no context and no API call, so the "dependency-free"
// property this boundary relies on is preserved.
import { supportEmail } from './supportContact';

// Catches any unhandled render/runtime error in the React tree and shows a friendly
// navy/gold fallback instead of a blank white screen. Kept dependency-free (no context,
// no API calls) so it can render even when the rest of the app is broken.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface for diagnostics; a real error-reporting hook can be wired in here later.
    console.error('ErrorBoundary caught an error:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={styles.page}>
        <header style={styles.topbar}>
          <div style={styles.wordmark}>Enko <span style={styles.wordmarkLight}>Portal</span></div>
        </header>
        <main style={styles.main}>
          <div style={styles.card}>
            <div style={styles.badge}><span style={styles.badgeMark}>!</span></div>
            <h1 style={styles.title}>Something went wrong</h1>
            <p style={styles.msg}>
              Our team has been notified. Please try refreshing the page.
            </p>
            <button style={styles.btn} type="button" onClick={() => window.location.reload()}>
              Refresh page
            </button>
            {/* SUPPORTCFG: shown only when an address is configured. No address, no line -
                never a hardcoded fallback. */}
            {supportEmail() && (
              <p style={styles.contact}>
                Need help?{' '}
                <a style={styles.link} href={`mailto:${supportEmail()}`}>Contact support</a>
              </p>
            )}
          </div>
        </main>
      </div>
    );
  }
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#edecea',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: '#1a2744',
  },
  topbar: {
    background: '#1a2744',
    borderBottom: '3px solid #c9a84c',
    padding: '20px 24px',
    textAlign: 'center',
  },
  wordmark: { fontSize: '20px', fontWeight: 800, letterSpacing: '0.28em', textTransform: 'uppercase', color: '#c9a84c' },
  wordmarkLight: { color: '#ffffff' },
  main: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 20px' },
  card: {
    background: '#ffffff',
    border: '0.5px solid rgba(26,39,68,0.1)',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(26,39,68,0.08)',
    maxWidth: '480px',
    width: '100%',
    padding: '40px 32px',
    textAlign: 'center',
  },
  badge: {
    width: '56px', height: '56px', margin: '0 auto 20px', borderRadius: '50%',
    background: '#1a2744', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  badgeMark: { color: '#c9a84c', fontSize: '30px', fontWeight: 800, lineHeight: 1 },
  title: { fontSize: '20px', fontWeight: 700, margin: '0 0 12px 0', color: '#1a2744' },
  msg: { fontSize: '15px', lineHeight: 1.6, color: '#4a5568', margin: '0 0 28px 0' },
  btn: {
    background: '#c9a84c', color: '#1a2744', fontSize: '15px', fontWeight: 700,
    border: 'none', borderRadius: '8px', padding: '12px 32px', cursor: 'pointer',
  },
  contact: { marginTop: '28px', fontSize: '13px', color: '#9ba8c0', lineHeight: 1.7 },
  link: { color: '#c9a84c', textDecoration: 'none', fontWeight: 600 },
};

export default ErrorBoundary;
